import { ApiResponse, TokenData, CancellationReason, LeadAssigneeChangeReason } from '../models';
import * as http from './http';
import ApiService from './service';

export class LeadAssigneeChangeReasonService extends ApiService {
  public async loadAllChangeReason() {
    const url = `${this.apiDomain}/api/settings/lead-asignee-change-reasons`;

    const resposne = await http.get<ApiResponse<LeadAssigneeChangeReason[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createChangeReason(data: CancellationReason, id?: string) {
    const url = `${this.apiDomain}/api/settings/lead-asignee-change-reason`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateChangeReason(data: LeadAssigneeChangeReason, id?: string) {
    const url = `${this.apiDomain}/api/settings/lead-asignee-change-reason/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteChangeReason(id?: string) {
    const url = `${this.apiDomain}/api/settings/lead-asignee-change-reason/${id}`;

    const response = await http.remove<ApiResponse<LeadAssigneeChangeReason>>(
      url,
      this.store
    );
    return response.data;
  }
}
